import { render, staticRenderFns } from "./setting2.vue?vue&type=template&id=18365c89&"
import script from "./setting2.vue?vue&type=script&lang=ts&"
export * from "./setting2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports